import { margins } from '@olist/styled-system';
import styled, { css } from 'styled-components';

const scaleSmallIcon = (left) => css `
  width: 16px;
  height: 16px;
  ${left
    ? css `
        margin-left: ${(props) => props.theme.olist.components.badge.svg.margin};
      `
    : css `
        margin-right: ${(props) => props.theme.olist.components.badge.svg.margin};
      `}
`;
const StyledBadge = styled.span(({ theme: { olist: { components: { badge }, }, }, variation = 'primary', }) => css `
    height: 24px;
    padding-inline: ${badge['padding-inline']};
    font-family: ${badge['font-family']};
    font-size: ${badge['font-size']};
    line-height: ${badge['line-height']};
    font-weight: ${badge['font-weight']};

    display: inline-flex;
    align-items: center;

    background: ${badge.variation[variation].background};
    color: ${badge.variation[variation].color};

    border-radius: ${badge.radius.default};

    ${margins}

    svg {
      ${scaleSmallIcon()}
    }
  `);

export { StyledBadge, scaleSmallIcon };
